import { useQuery } from 'react-query';
import { getPatientLists } from '../api/getPatientLists';

const usePatientLists = () => {
  const result = useQuery('patient_list', () => getPatientLists(), {
    refetchOnWindowFocus: false,
    staleTime: 5000,
  });
  return result;
};

export default usePatientLists;
